import React from 'react';

const Support = () => {
  return (
    <div className="policy-container" style={{padding: '2rem', maxWidth: '800px', margin: '0 auto'}}>
      <h1>Contact Us</h1>
      <p>We are here to help you navigate your legal strategy.</p>

      <div style={{marginTop: '2rem', background: '#f8f9fa', padding: '1.5rem', borderRadius: '8px'}}>
        <h3>Abhikalp (ARK Strategic Management Consultancy Services)</h3>
        <p><strong>Registered Address:</strong><br/>
        401, Bliss,City of Joy, JSD Road,<br/>
        Mulund West, Mumbai, Maharashtra - 400080</p>

        <p><strong>Email:</strong> support@abhikalpconsulting.com</p>
        <p><strong>Phone:</strong> +91 9082541950</p>
        <p><strong>Operating Hours:</strong> Monday to Friday, 9:00 AM - 6:00 PM</p>
      </div>
    </div>
  );
};

export default Support;